import {atom} from "jotai"

export const currentStepIdAtom = atom(0)
